import type { HomePage } from '~/api'

export const usePageStore = defineStore('page', () => {
  const api = useApi()

  const commonStore = useCommonStore()
  const { currentRegionId } = storeToRefs(commonStore)

  const mainPage = ref<HomePage | null>(null)

  const fetchMainPage = async () => {
    if (!currentRegionId.value) return
    mainPage.value = (
      await api.public.home({
        region_id: currentRegionId.value,
      })
    ).data
  }

  watch(currentRegionId, () => {
    if (currentRegionId.value) {
      fetchMainPage()
    }
  })

  return {
    mainPage,

    fetchMainPage,
  }
})
